import * as FullStory from '@fullstory/browser';

export const track = (argument: any) => {
  if (typeof window.dataLayer !== 'object') {
    return;
  }
  if (typeof argument === 'string') {
    window.dataLayer.push({
      event: argument,
    });
  } else {
    window.dataLayer.push({
      ...argument,
    });
  }
};

export const bwClickTracking = (event: any, customVariables = {}) => {
  if (window.bwtag) {
    const { dataset } = event.target;
    window.bwtag('record', 'click', { analyticsID: dataset?.analytics, ...customVariables }, event);
  }
};

export const bwNPSScoreTracking = (score: string, source: string, bookingID?: string, feedback?: string) => {
  if (!window.isHeadless && window.bwtag) {
    window.bwtag('record', 'nps_widget:score', {
      score,
      feedback: feedback ?? null,
      source,
      bookingID: bookingID ?? null,
      fsSession: !window.isHeadless ? FullStory.getCurrentSessionURL(true) : 'NA',
    });
  }
};
